import { createComponent } from '@carvana/merch-components';

export const Dropdowns = createComponent('div', {
  className: 'flex max-w-[400px] flex-col gap-xl'
});
